import React from "react";
import "./App.css";
import GlobalStyle from "./FixedStyled";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "react-multi-carousel/lib/styles.css";
import HomePage from "./BaseComponents/Homepage";
import Aboutus from "./BaseComponents/Aboutus";
import Services from "./BaseComponents/Services";
import Contactus from "./BaseComponents/Contactus";
import Contactusingmui from './Rootelements/Contactussubfiles/Contactusingmui';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/aboutus" element={<Aboutus />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contactpage" element={<Contactus />} />
      </Routes>
    </Router>
  );
}

export default App;
